import React from 'react';

const LeagueTableRow = ({ data }) => {
  return (
    <tr>
      <td>
        <span className="hi-border" style={{ backgroundColor: `${data?.clr}` }}></span>
        <span className="d-inline-block align-middle">{data?.plc}</span>
      </td>
      <td>
        <div className="des-wrap">
          <span className="des-text">{data?.team?.nm || data?.team}</span>
        </div>
      </td>
      <td>{data?.pld}</td>
      <td>{data?.w}</td>
      <td>{data?.d}</td>
      <td>{data?.l}</td>
      <td>{data?.scr}</td>
      <td>{data?.con}</td>
      <td>{data?.dif}</td>
      <td>{data?.pts}</td>
    </tr>
  );
};

export default LeagueTableRow;
